import React, { useState, useRef, useEffect } from "react";
import {
  FaThLarge,
  FaUserGraduate,
  FaBullhorn,
  FaClipboardList,
  FaEnvelopeOpenText,
  FaCalendarCheck,
  FaChalkboardTeacher,
  FaEdit,
  FaUserShield,
  FaSignOutAlt,
  FaBars,
  FaFileAlt,
  FaChevronDown,
  FaChevronUp
} from "react-icons/fa";
import { useLocation } from "react-router-dom";
import "./Menu.css";

function Menu({ onMenuClick, isOpen, toggleMenu }) {
  const [activeSection, setActiveSection] = useState(
    localStorage.getItem("activePage") || "Overview"
  );
  const [isReportsOpen, setIsReportsOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef(null);

  useEffect(() => {
    const storedPage = localStorage.getItem("activePage");
    if (storedPage) {
      setActiveSection(storedPage);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!isOpen) {
      closeDropdowns();
      disableScroll();
      setIsReportsOpen(false);
    } else {
      enableScroll();
    }
    return () => enableScroll();
  }, [isOpen]);

  const closeDropdowns = () => {
    setIsReportsOpen(false);
  };

  const disableScroll = () => {
    const menuEl = menuRef.current;
    if (menuEl) {
      menuEl.style.overflow = "hidden";
    }
  };

  const enableScroll = () => {
    const menuEl = menuRef.current;
    if (menuEl) {
      menuEl.style.overflow = "auto";
    }
  };

  const handleMenuItemClick = (section, isSubItem = false) => {
    // LOGOUT → IMMEDIATELY GO TO LOGIN PAGE (NO REFRESH)
    if (section === "Logout") {
      const confirmLogout = window.confirm("Are you sure you want to log out?");
      if (confirmLogout) {
        localStorage.clear();
        sessionStorage.clear();

        // CHANGE "/login" TO YOUR ACTUAL LOGIN PAGE PATH
        window.location.href = "/login";   // This makes it go IMMEDIATELY

        // If you use React Router, you can also use:
        // navigate("/login");   // (uncomment if you have useNavigate)

        return;
      }
      return;
    }

    if (section === "PrivacyPolicy" || section === "TermsOfUse") {
      onMenuClick(section);
      return;
    }

    if (section === "Reports" && !isSubItem) {
      setIsReportsOpen((prev) => !prev);
      return;
    }

    const pageMap = {
      Overview: "Overview",
      Reports: "Reports",
      Admin: "Admin",
      Student: "Student",
      Teacher: "Teacher",
      "Attendance Report": "AttendanceReport",
      "Assignment Report": "AssignmentReport",
      "Result Report": "ResultReport"
    };

    const selected = pageMap[section] || section;
    setActiveSection(isSubItem ? section : selected);
    localStorage.setItem("activePage", selected);
    onMenuClick(selected);

    if (isSubItem) {
      setIsReportsOpen(false);
    }
  };

  const menuItems = [
    { name: "Overview", icon: <FaThLarge />, label: "Overview" },
    { name: "AdmissionList", icon: <FaEdit />, label: "Admission" },
    { name: "Student", icon: <FaUserGraduate /> },
    { name: "Teacher", icon: <FaChalkboardTeacher /> },
    { name: "Announcement", icon: <FaBullhorn /> },
    { name: "Assignment", icon: <FaClipboardList /> },
    { name: "Circular", icon: <FaEnvelopeOpenText /> },
    { name: "Attendance", icon: <FaCalendarCheck /> },
    {
      name: "Reports",
      icon: <FaFileAlt />,
      label: "Reports",
      subItems: [
        { name: "Attendance Report", label: "Attendance Report", icon: <FaCalendarCheck /> },
        { name: "Assignment Report", label: "Assignment Report", icon: <FaClipboardList /> },
        { name: "Result Report", label: "Result Report", icon: <FaFileAlt /> }
      ]
    },
    { name: "Logout", icon: <FaSignOutAlt />, label: "Logout" }
  ];

  return (
    <>
      {isOpen && (
        <div className="menu-container">
          <div ref={menuRef} className="menu expanded active">
            <div className="menu-links">
              {menuItems.map(({ name, icon, label, subItems }) => (
                <div key={name} className="menu-item-wrapper">
                  <div
                    className={`menu-item ${activeSection === name ? "active" : ""}`}
                    onClick={() => handleMenuItemClick(name)}
                  >
                    <span className="menu-icon">{icon}</span>
                    <span className="menu-text">{label || name}</span>
                    {subItems && (
                      <span className="dropdown-icon">
                        {isReportsOpen ? <FaChevronUp /> : <FaChevronDown />}
                      </span>
                    )}
                  </div>

                  {subItems && isReportsOpen && name === "Reports" && (
                    <div className="submenu">
                      {subItems.map((subItem) => (
                        <div
                          key={subItem.name}
                          className={`submenu-item ${activeSection === subItem.name ? "active" : ""}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMenuItemClick(subItem.name, true);
                          }}
                        >
                          <span className="menu-icon">{subItem.icon}</span>
                          <span className="submenu-text">{subItem.label}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <button
        className="menu-toggle-btn"
        onClick={toggleMenu}
        aria-label="Toggle Menu"
        title="Toggle Menu"
      >
        <FaBars />
      </button>
    </>
  );
}

export default Menu;